export default "__VITE_ASSET__CNvE4OXa__"